<template>
  <pop-box ref="myPopbox" class="upload-popbox" :hasNotButton="true" :title="title" @closeDialog="$emit('close')"
           :width="750">
    <el-form ref="form" :model="formData" label-width="100px">
      <el-form-item label="角色名称">
        <el-input v-model="formData.roleName"></el-input>
      </el-form-item>
      <el-form-item label="描述">
        <el-input type="textarea" :rows="2" v-model="formData.roleDesc"></el-input>
      </el-form-item>
    </el-form>
    <div class="dialog-footer btn-wrapper">
      <el-button class="btnx-normal btn-blue" @click="onSave">保存</el-button>
      <el-button class="btnx-normal btn-gray" @click="onClose">关闭</el-button>
    </div>
  </pop-box>
</template>
<script>
  import {getAction} from "@/service/http/api";
  import des from '@/service/des'
  import editMixin from "@/mixin/editModal"
  export default {
    name: 'Edit',
    props: ['rowId','title','mode'],
    mixins:[editMixin],
    data() {
      return {
        formData:{
          id:null,
          roleName:null,
          roleDesc:null
        },
        url:{
          add:'/role/add',
          edit:'/role/edit',
          query:'/role/queryById'
        }
      }
    },
    methods: {
      pwdChange(){
        this.formData.strPwd = des.des_encrypt(this.formData.pwd);
      },
    },
  }
</script>

<style lang="scss" scoped>
  .img-item{
    margin: 20px 40px;
    float: left;
    position: relative;
    width: 300px;
    p{
      line-height: 30px;
      color: #0D74FE;
    }
    .left,.right{
      position: absolute;
      top: 0;
      width: 30px;
      height: 300px;
      background: #FFFFFF;
    }
    .left{
      left: 0;
    }
    .right{
      right: 0;
    }
  }
  .img-item img{
    width: 240px;
    height: 300px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/role_management/edit.vue